'use client";';

import { c as _c } from "react/compiler-runtime";
import { BriefcaseBusiness, Headphones, Presentation, User, UserCog } from "lucide-react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../ui/card";
import { Button } from "../ui/button";
import { cn } from "@/lib/utils";
import { usePopup } from "@/providers/popup-provider";
type HaveMoreQuestionCardProps = {
  serviceId?: string;
};
export const HaveMoreQuestionCard = t0 => {
  const $ = _c(12);
  const {
    serviceId
  } = t0;
  const {
    openPopup
  } = usePopup();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = cn("ring-primary/20 bg-primary/10 dark:bg-card dark:ring-primary/20 w-full shadow-md sm:w-auto");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <CardHeader><CardTitle>Have More Questions?</CardTitle><CardDescription>Our Learning Advisors are here to help you choose the right path.</CardDescription></CardHeader>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <li className="flex items-center gap-2 text-sm"><User className="text-primary" size={18} />Speak with an Expert</li>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li className="flex items-center gap-2 text-sm"><UserCog className="text-primary" size={18} />Get Personalized Guidance</li>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <li className="flex items-center gap-2 text-sm"><Presentation className="text-primary" size={18} />Know More About Training</li>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <CardContent><ul className="m-0 flex list-none flex-col gap-3 p-0">{t3}{t4}{t5}<li className="flex items-center gap-2 text-sm"><BriefcaseBusiness className="text-primary" size={18} />Request a Corporate Proposal</li></ul></CardContent>;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== openPopup || $[7] !== serviceId) {
    t7 = () => openPopup({
      type: "talk-to-advisor",
      title: "Talk to a Learning Advisor",
      description: "Submit this form to trigger an advisor callback to your phone.",
      data: {
        serviceId,
        submitLabel: "Initiate Call"
      }
    });
    $[6] = openPopup;
    $[7] = serviceId;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Headphones className="size-4" />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7) {
    t9 = <Card className={t1}>{t2}{t6}<CardFooter className="border-0 bg-transparent"><Button className="w-full" onClick={t7}>{t8} Talk to Advisor</Button></CardFooter></Card>;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};